import api from '@/api';
import eventBus from '@/utils/eventBus';

export const UserFolderTree = {
  data () {
    return {
      folderTree: [],
      userFolderProjectFrom: {
        folderId: '',
        projectId: '',
        folderName: ''
      },
      defaultProps: {
        children: 'children',
        label: 'folderName'
      },
      popoverFlg: false
    };
  },
  methods: {
    getUserFolderTree (queryString, cb) {
      if (this.folderTree.length == 0) {
        api.getUserFolderTree({ params: { 'folderId': '1' } }).then((res) => {
          let json = res.data;
          if (json.status === '200' && json.data != null) {
            this.folderTree = json.data;
          } else {
            this.$notify.error('获取用户文件夹分类错误');
          }
        }).catch((e) => {
          console.log(e);
          this.$notify.error('网络异常');
        });
      }
    },
    handleNodeClick (data) {
      this.popoverFlg = false;
      this.userFolderProjectFrom.folderName = data.folderName;
      this.userFolderProjectFrom.folderId = data.folderId;
    }
  }
};
